import employeeBreadcrumbStore from "@/stores/employeeBreadcrumbStore";
import orderStore from "@/stores/order.store";
import { Breadcrumbs } from "@mui/material";
import { NavLink } from "react-router-dom";
import useBreadcrumbs, { Options } from "use-react-router-breadcrumbs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { reaction } from "mobx";
import DynamicOrderDocketBreadcrumb from "@/components/breadcrumb/orderBreadcrumb";

const Breadcrumb = () => {
    const { t } = useTranslation();
    const routes = [
        { path: "/", breadcrumb: t("breadcrumbs.HomePage") },
        {
            path: "/employees",
            breadcrumb: t("breadcrumbs.Employees"),
        },
        {
            path: "/employees/createEmployee",
            breadcrumb: t("breadcrumbs.NewEmployee"),
        },
        {
            path: "/employees/:id",
            breadcrumb: `${employeeBreadcrumbStore.employeeName}`,
        },
        {
            path: "/employees/:id/info",
            breadcrumb: t("display.GeneralInfo"),
        },
        {
            path: "/employees/:id/wallet",
            breadcrumb: t("breadcrumbs.DigitalWallet"),
        },
        {
            path: "/employees/:id/wallet/:orderId",
            breadcrumb: DynamicOrderDocketBreadcrumb,
        },
        {
            path: "/employees/:id/employeeOrders",
            breadcrumb: t("breadcrumbs.Orders"),
        },
        {
            path: "/employees/:id/employeeOrders/:orderId",
            breadcrumb: DynamicOrderDocketBreadcrumb,
        },
        {
            path: "/employees/:id/docs",
            breadcrumb: t("breadcrumbs.Docs"),
        },
        {
            path: "/digital-wallet",
            breadcrumb: t("breadcrumbs.DigitalWallet"),
        },
        {
            path: "/digital-wallet/list/:id",
            breadcrumb: null,
        },
        {
            path: "/settings",
            breadcrumb: t("sidebar.Settings"),
        },
        {
            path: "/settings/manage-users/user/0",
            breadcrumb: t("user.NewUser"),
        },
        {
            path: "/settings/manage-users/user",
            breadcrumb: null,
        },
        {
            path: "/settings/manage-users",
            breadcrumb: t("settings.menu.manageUsers"),
        },
        {
            path: "/settings/manage-profiles",
            breadcrumb: t("settings.menu.manageProfiles"),
        },
        {
            path: "/settings/manage-import",
            breadcrumb: t("settings.menu.manageImport"),
        },
        {
            path: "/settings/manage-interface",
            breadcrumb: t("settings.menu.importHistory"),
        },
        {
            path: "/settings/manage-organization-units",
            breadcrumb: t("settings.menu.manageOrganization"),
        },
        {
            path: "/settings/manage-employee-groups",
            breadcrumb: t("settings.menu.manageEmployeeGroups"),
        },
        {
            path: "/settings/manage-interface/transactions/:interfaceId",
            breadcrumb: null,
        },
        {
            path: "/settings/manage-interface/transactions",
            breadcrumb: t("interfaces.WalletTransaction"),
        },
        {
            path: "/digital-wallet/list/:id/transactions",
            breadcrumb: employeeBreadcrumbStore.employeeName ? `${employeeBreadcrumbStore.employeeName}` : "",
        },
        {
            path: "/digital-wallet/list/:transactionId/transactions/:orderId",
            breadcrumb: DynamicOrderDocketBreadcrumb,
        },
        {
            path: "/accounting/invoice/:id/:orderId",
            breadcrumb: DynamicOrderDocketBreadcrumb,
        },
        {
            path: "/digital-wallet/list",
            breadcrumb: t("breadcrumbs.DigitalWalletList"),
        },
        {
            path: "/digital-wallet/management",
            breadcrumb: t("breadcrumbs.DigitalWalletManagement"),
        },
        {
            path: "/orders",
            breadcrumb: t("breadcrumbs.Orders"),
        },
        {
            path: "/orders/:id",
            breadcrumb: DynamicOrderDocketBreadcrumb,
        },
        {
            path: "/forms",
            breadcrumb: t("breadcrumbs.FormsChat"),
        },
        {
            path: "/forms/createFunDay",
            breadcrumb: t("breadcrumbs.FunDayForm"),
        },
        {
            path: "/forms/createGroupOrder",
            breadcrumb: t("breadcrumbs.GroupOrderForm"),
        },
        {
            path: "/order/:id",
            breadcrumb: t("breadcrumbs.order.details"),
        },
        {
            path: "/accounting",
            breadcrumb: t("breadcrumbs.accounting"),
        },
        {
            path: "/accounting/invoice/:id",
            breadcrumb: t("breadcrumbs.accountingInvoice"),
        },
        {
            path: "/accounting/receipt/:id",
            breadcrumb: t("breadcrumbs.accountingReceipt"),
        },
    ];

    const breadcrumbOptions: Options = {
        excludePaths: ["/accounting/receipt", "/accounting/invoice"],
    };

    const breadcrumbs = useBreadcrumbs(routes, breadcrumbOptions);
    const [, forceUpdate] = useState(false);

    reaction(
        () => orderStore.selectedOrderDocketNumber,
        () => {
            forceUpdate((prev: boolean) => !prev);
        }
    );

    return (
        <Breadcrumbs separator="››" className="breadcrumb-button breadcrumbsStyle">
            {breadcrumbs.map(({ breadcrumb, key, match }) => (
                <div key={key}>
                    <NavLink className="font-style breadcrumbs" key={match.pathname} to={match.pathname}>
                        {breadcrumb}
                    </NavLink>
                </div>
            ))}
        </Breadcrumbs>
    );
};

export default Breadcrumb;
